import mixpanel from 'mixpanel-browser';

const MixPanel = '0eda3e171d010f856cb722ffdac8baa9';  

mixpanel.init(MixPanel, {
  persistence: 'localStorage',
  debug: true,
  track_pageview: true, 
});

export default mixpanel;
